import React from 'react'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { FooterSection, LeadingTitle } from '@components'
import './CreditCard.scss'
import { CreditCardAPI, ShortDescriptionAPI } from '@api'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import HeaderSection from '../../../common/components/Header/HeaderSection'
import LandingCardBox from '../../../common/components/LandingCardBox'
import CardPromo from '../../../common/components/Cards/CardPromo'

const Container = styled.div`
  padding-top: 72px;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const InvestorContainer = styled.div`
  margin-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const PromoContainer = styled.div`
  background-color: #f9f9f9;
  margin-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const CreditCard = function () {
  const { t } = useTranslation()
  const [data, setdata] = useState([])
  const [shortDesc, setShortDesc] = useState({})
  const [isLoading, setisLoading] = useState(false)

  useEffect(() => {
    setisLoading(true)
    loadShortDescData()
  }, [])

  const loadData = async function () {
    const reportData = await CreditCardAPI('')
    setdata(reportData.data.data)
  }

  const loadShortDescData = async () => {
    const { data } = await ShortDescriptionAPI({ loc: 'credit_card' })
    setShortDesc(data.data[0])
    setisLoading(false)
    loadData()
  }
  return (
    <div>
      <Container>
        <HeaderSection
          title={shortDesc.title}
          group={t('your_daily_solution')}
          description={shortDesc.description}
          banner={shortDesc.banner}
          // showButton={true}
          textButton={t('dapatkan_kartu_kredit_sekarang')}
        />
      </Container>

      <InvestorContainer>
        <div className="p-0 m-0 container-fluid">
          <div className="pt-4 px-3 pb-0">
            <div className="mb-4 mb-lg-0 mx-0 px-lg-5 mx-lg-5 flex align-items-center position-relative row">
              <div className="row">
                <div className="col-12">
                  <h4>{t('pilih_kartu_kredit')}</h4>
                </div>
              </div>
              <div className="row mt-2">
                {data.map((item) => {
                  return (
                    <div className="col-lg-4">
                      <LandingCardBox
                        title={item.title}
                        description={item.description}
                        image={item.imageBannerDesktop}
                        cardImage={item.imageCardDesktop}
                        redirectUrl={'/credit-card/' + item.id}
                      />
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </InvestorContainer>

      {/* <PromoContainer>
        <div className="p-0 m-0 container-fluid">
          <div className="pt-4 px-3 pb-0">
            <div className="mb-4 mb-lg-0 mx-0 px-lg-5 mx-lg-5 flex align-items-center position-relative row">
              <div className="row">
                <div className="col-12">
                  <h4>{t("promo_kartu_kredit")}</h4>
                </div>
              </div>
              <div className="row mt-2">
                {data.map((item) => {
                  return (
                    <div className="col-12 col-lg-4">
                      <CardPromo
                        text={item.description}
                        src="https://bkps123-58c9d.web.app/images/credit-cards/credit-card-promo.png"
                        title={item.title}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </PromoContainer> */}
      <FooterSection currentPage={t('kartu_kredit')} />
    </div>
  )
}

export default CreditCard
